import { useMemo } from 'react';

export const useSelection = (selectedRowIds: Record<string | number, boolean>) => {
  return useMemo(() => Object.keys(selectedRowIds), [selectedRowIds]);
};
